// Constants
import { TYPES } from '../types/types.constants';
import { initialStateQr } from './initial.state';

export const qrReducer = (state = initialStateQr, action) => {

    switch (action.type) {
        case TYPES.QR.SET_QR:

            return {
                ...state,
                transaction: {
                    ...action.payload
                }
            }
        case TYPES.QR.RESET_TRANSACTION_QR:
            return {
                ...state,
                transaction: initialStateQr.transaction
            }
        case TYPES.APP.RESET:
            return {
                ...initialStateQr
            }

        default:
            return state;
    }
};